import React, { useState } from 'react';
import { Button } from 'src/shared/components/ui/button';
import { PrimaryButton } from 'src/shared/components/button/Button';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from 'src/shared/components/ui/sheet';
import CMSArticle from 'src/shared/components/cms-article/CMSArticle';

type ReportingFrameworksProps = {
    slugPrefix?: string;
};

const FRAMEWORKS = ['TNFD', 'CSRD', 'GRI'];

const ReportingFrameworks = ({ slugPrefix = 'site' }: ReportingFrameworksProps) => {
    const [selectedFramework, setSelectedFramework] = useState<string | null>(null);

    return (
        <>
            <div className='text-sm text-grey-80 text-right'>
                Reporting frameworks:
                {FRAMEWORKS.map(framework => (
                    <Button
                        key={framework}
                        variant='outline'
                        size='mini'
                        roundness='Round'
                        className='ml-2'
                        onClick={() => setSelectedFramework(framework)}
                    >
                        {framework}
                    </Button>
                ))}
            </div>

            <Sheet open={!!selectedFramework} onOpenChange={open => !open && setSelectedFramework(null)}>
                <SheetContent className='flex flex-col overflow-hidden sm:max-w-md' side='right'>
                    <SheetHeader>
                        <SheetTitle className='pr-8 text-xl font-normal'>{selectedFramework}</SheetTitle>
                    </SheetHeader>
                    <div className='flex-1 overflow-y-auto py-4'>
                        {selectedFramework && (
                            <CMSArticle shouldShowTitle={false} slug={`${slugPrefix}-${selectedFramework.toLowerCase()}-framework`} />
                        )}
                    </div>
                    <div className='flex justify-end border-t pt-4'>
                        <PrimaryButton onClick={() => setSelectedFramework(null)}>Close</PrimaryButton>
                    </div>
                </SheetContent>
            </Sheet>
        </>
    );
};

export default ReportingFrameworks;
